import "rxjs"
import {ajax} from "rxjs/observable/dom/ajax"
import config from "../config"
import {buildUserInfoPayload} from "./CurrentUserInfoEpic"
import errorHandlerBuilder from "./errorHandlerBuilder"
import {
  ACTION_AUTHORIZATION_INVITATION_RESULTS_ERROR,
  ACTION_AUTHORIZATION_INVITATION_RESULTS_LOADING,
  ACTION_AUTHORIZATION_INVITATION_RESULTS_LOADED,
  PATH_SEND_INVITATIONS
} from "../constants"

const api_server_host = config.api_server_host

const errorHandler = errorHandlerBuilder(ACTION_AUTHORIZATION_INVITATION_RESULTS_ERROR)

const epic = (action$, store)=>
  action$.ofType(ACTION_AUTHORIZATION_INVITATION_RESULTS_LOADING)
    .mergeMap(action => {

      const tokenData = store.getState().user
      const token = tokenData.access_token
      const type = tokenData.token_type

      return ajax({
        method: 'GET',
        url: `${api_server_host}${PATH_SEND_INVITATIONS}?${$.param(action.payload)}`,
        headers: {
          Authorization: `${type} ${token}`
        },
        responseType: 'json'
      }).map(data=> {

        return {
          type: ACTION_AUTHORIZATION_INVITATION_RESULTS_LOADED,
          payload: data.response
        }
      }).catch(errorHandler)

    })

export default epic



// WEBPACK FOOTER //
// ./src/epics/InvitationResultsEpic.js